import React from 'react'
import { Navigate } from 'react-router-dom'
import { Permissions } from '@wove/common/permissions'
import useUserStore from '@src/state/user'
import { Alert } from '@wove/web-ui'

interface PermissionRequiredProps {
  permissions: Permissions[]
  children: React.ReactNode
  fallback?: React.ReactNode
  redirectTo?: string
  requireAll?: boolean
}

export const PermissionRequired: React.FC<PermissionRequiredProps> = ({ 
  permissions, 
  children, 
  fallback,
  redirectTo,
  requireAll = true
}) => {
  const user = useUserStore((state) => state.user)
  const userPermissions = useUserStore((state) => state.permissions)
  
  if (!user) {
    return <Navigate to="/login" replace />
  }

  const hasPermission = requireAll
    ? permissions.every(permission => userPermissions.includes(permission))
    : permissions.some(permission => userPermissions.includes(permission))

  if (!hasPermission) {
    if (fallback) {
      return <>{fallback}</>
    }
    
    if (redirectTo) {
      return <Navigate to={redirectTo} replace />
    }

    return (
      <div className="p-4">
        <Alert variant="error">
          You do not have permission to access this feature.
        </Alert>
      </div>
    )
  }

  return <>{children}</>
}